<template>
  <div>
    <div class="header-container">
      <div class="header-left">
        <div
          class="header"
          style="padding-top: 8px;"
        >
          <a href="/">
            <img
              src="./../../public/ua-logo-reversed-white.svg"
              width="140"
              height="48"
              alt="UofA logo"
            >
            <span class="title">Course Creation</span>
          </a>
        </div>
        <slot name="header-left" />
      </div>
      <div class="header-right">
        <slot name="rightside" />
        <v-menu
          v-if="username"
          open-on-click
          offset-y
        >
          <template #activator="{ on }">
            <v-btn v-on="on">
              {{ username }}
              <v-icon right>
                mdi-chevron-down
              </v-icon>
            </v-btn>
          </template>

          <v-list>
            <AccessConfig v-if="isadmin" />
            <v-list-item @click="logout()">
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <div class="text-center">
      <v-snackbar
        v-model="snackbar"
        :multi-line="multiline"
      >
        {{ text }}
        <v-btn
          color="primary"
          text
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex';
import AccessConfig from '@/components/modals/AccessConfig.vue';

export default {
    name: 'CCHeader',
    components: {
        AccessConfig,
    },
    props: {
        username: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        text: '',
        snackbar: false,
        multiline: true,
    }),
    computed: {
        ...mapState(['isadmin']),
    },
    methods: {
        logout() {
            this.$router.push({ path: 'logout' });
        },
    },
};
</script>

<style lang="scss" scoped>
.header-container {
  display: flex;
  width: 100%;
  flex-direction: row;
  margin-left: 0em;
  height: 64px;
  background-color: #275D38;
  justify-content: space-between;
  color: #fff
}

.header-item {
    margin-left: 1em;
}
.header-left {
    display: flex;
    flex-direction: row;
}
.header-right {
    display: flex;
    flex-direction: row;
}
img {
  margin-left: 8px;
  padding: 8px 0;
}
.header-container .title {
    color: #F2CD00;
    line-height: 33px;
    font-size: 25px !important;
    font-weight: 300;
    letter-spacing: 0 !important;
    padding-left: 5px;
    vertical-align: middle;
}
.header-container a:hover {
    text-decoration: none;
}

.v-btn {
  background: transparent !important;
  box-shadow: none;
  color: #fff !important;
  text-transform: none;
  letter-spacing: normal;
  font-size: 1rem;
  font-weight: 400;
}
.v-btn:not(.v-btn--text):not(.v-btn--outlined):hover:before {
  opacity: 0;
}
.v-btn:not(.v-btn--text):not(.v-btn--outlined):focus:before {
  opacity: 0;
}
.v-btn:not(.v-btn--round).v-size--default {
    height: auto;
}
button:focus {
  outline: 1px auto -webkit-focus-ring-color;
}
.v-list {
  padding: 0;
}
.v-icon.mdi-chevron-down {
  margin-left: 4px;
  margin-top: 2px;
}
@media only screen and (max-width: 720px) {
  .title {
    display: none;
  }
}
</style>
